module.exports = __webpack_public_path__ + "img/Identity-Pattern5.c579d552.svg";